<template>
  <section class="section container pt-0">
    <warehouse-datatable />
  </section>
</template>

<script>
import WarehouseDatatable from "./warehouse_datatable/Index.vue";

export default {
  name: "InventoryWarehouse",
  components: {
    WarehouseDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
